import { Tasks } from '../../../../utils/types';
import { fetchTaskerById } from '../../../../api/taskers';
import { getTaskerAverageRating } from '../../../../api/tasks_reviews';
import { generateAssignedTaskEmail } from '../../../../email-templates/assignedTask';
import { getFileFromUrl } from '../../global';
import { EmailAttachment } from '../../../../types/emails';
import { supabase } from 'common/src/supabase';

export const handleAssignedStatus = async (task: Tasks) => {
  // Fetch assigned taskers for the given task
  const { data: assignedTaskers, error } = await supabase
    .from('assigned_taskers')
    .select('task_id, tasker_id')
    .eq('task_id', task.id);

  if (error) {
    throw new Error(`Error fetching assigned task offers: ${error.message}`);
  }

  if (!assignedTaskers || assignedTaskers.length === 0) {
    throw new Error(`No assigned taskers found for task ID: ${task.id}`);
  }

  const taskerPromises = assignedTaskers.map(
    async (item: { task_id: number; tasker_id: number }) => {
      const tasker = await fetchTaskerById(item.tasker_id);
      if (!tasker) {
        throw new Error(`No tasker found for ID: ${item.tasker_id}`);
      }
      const taskerRating = await getTaskerAverageRating(item.tasker_id);

      return { tasker, taskerRating };
    }
  );

  const taskerData = await Promise.all(taskerPromises);

  const emailContent = generateAssignedTaskEmail({
    task: task,
    taskers: taskerData.map(({ tasker, taskerRating }) => ({
      ...tasker,
      rating: taskerRating || undefined,
    })),
  });

  const subject =
    taskerData.length > 1
      ? 'Encontramos los Taskers perfectos!!'
      : 'Encontramos el Tasker perfecto!!';

  const attachments: EmailAttachment[] = [];

  for (const { tasker } of taskerData) {
    // REGULAR ALUMN CERTIFICATE
    if (tasker.certificate_regular_alumn_url) {
      try {
        const regularAlumnFile = await getFileFromUrl(tasker.certificate_regular_alumn_url);
        const base64Content = regularAlumnFile.base64;
        if (typeof base64Content === 'string') {
          attachments.push({
            content: base64Content.split(',')[1],
            filename: `certificado_alumno_regular_${tasker.id}.pdf`,
            type: 'application/pdf',
            disposition: 'attachment',
          });
        }
      } catch (error) {
        console.error('Error fetching regular alumn certificate:', error);
        // Don't throw, just log the error and continue
      }
    }

    // CRIMINAL RECORD CERTIFICATE
    if (tasker.certificate_criminal_record_url) {
      try {
        const criminalRecordFile = await getFileFromUrl(tasker.certificate_criminal_record_url);
        const base64Content = criminalRecordFile.base64;
        if (typeof base64Content === 'string') {
          attachments.push({
            content: base64Content.split(',')[1],
            filename: `certificado_antecedentes_${tasker.id}.pdf`,
            type: 'application/pdf',
            disposition: 'attachment',
          });
        }
      } catch (error) {
        console.error('Error fetching criminal record certificate:', error);
        // Don't throw, just log the error and continue
      }
    }
  }

  return { emailContent, subject, attachments };
};
